import { Form, Formik, FormikProps } from "formik";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import symbolApi, { AddSymbolsDataType } from "../../../APIs/symbols";
import {
  BrowseFile,
  Button,
  FormContainer,
  Input,
  Typography,
} from "../../../designComponents";
import {
  FileWithKeys,
  getFileURL,
  requestAPI,
  uploadFilesToS3,
} from "../../../utils";
import { AddSymbolStyled } from "./style";

const AddSymbol = () => {
  const formikRef = useRef<FormikProps<AddSymbolsDataType>>(null);
  const [files, setFiles] = useState<File[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [initialValues, _setInitialValues] = useState<AddSymbolsDataType>({
    symbolName: "",
    uploadSymbol: [],
  });

  const handleAddSymbol = async (values: typeof initialValues) => {
    try {
      if (files.length === 0) return;
      setLoading(true);
      let fileWithKeys: FileWithKeys[] = [];
      if (files && files.length > 0) {
        fileWithKeys = (await uploadFilesToS3(files)) as FileWithKeys[];
      }

      if (fileWithKeys && fileWithKeys.length === files.length) {
        await requestAPI(
          symbolApi.addSymbols({
            symbolName: values.symbolName,
            uploadSymbol: values.uploadSymbol
              ? values.uploadSymbol?.map((val) => ({
                  url: val?.file ? getFileURL(fileWithKeys, val?.file) : "",
                  title: val.title,
                }))
              : [],
          }),
        );
      }
      setLoading(false);
      navigate(-1);
      toast("Symbol Added Successfully");
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <AddSymbolStyled>
      <Typography variant="title" className="heading">
        Add Symbols
      </Typography>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        onSubmit={handleAddSymbol}
      >
        {({ values, setFieldValue, touched, errors, handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <FormContainer
                label="Symbol Name"
                error={touched.symbolName ? errors.symbolName : ""}
              >
                <Input
                  name="symbolName"
                  placeholder="Symbol Name"
                  value={values.symbolName}
                  onChange={(e) => setFieldValue("symbolName", e.target.value)}
                />
              </FormContainer>
              <FormContainer
                label="Upload Symbols"
                error={
                  touched.uploadSymbol &&
                  values.uploadSymbol.length === 0 &&
                  typeof errors.uploadSymbol === "string"
                    ? errors.uploadSymbol
                    : ""
                }
              >
                <div className="browse-files">
                  <Typography
                    variant="caption"
                    fontColor="border"
                    className="upload-logo-svg"
                  >
                    You can upload a logo in either SVG, PNG, or JPG format, and
                    you also have the option to add multiple logos.
                  </Typography>
                  <BrowseFile
                    setFiles={(browsedFiles: File[]) => {
                      setFiles(browsedFiles);

                      const newSymbols = browsedFiles.map((file) => ({
                        file,
                        title: file.name,
                      }));

                      setFieldValue("uploadSymbol", newSymbols);
                    }}
                    files={files}
                    accepts=".png, .svg, .jpeg, .jpg"
                    multiple
                  />
                </div>
              </FormContainer>
              <Button
                variant="secondary"
                type="submit"
                isLoading={loading}
                size="lg"
                style={{
                  padding: "7px 30px",
                }}
              >
                Continue
              </Button>
            </Form>
          );
        }}
      </Formik>
    </AddSymbolStyled>
  );
};

export default AddSymbol;
